import { defineStore } from 'pinia'
import store from '~/store'
import { SystemLanguageEnum } from '~/types/const'
// 系统语言
export interface SystemLanguageType {
    id?: number
    name: string
    code: SystemLanguageEnum
}
const useSystemLaunageStore = defineStore('systemLaunage', ()=> {
    const languageList = ref<SystemLanguageType[]>([
        { id: 1, name: '简体中文', code: SystemLanguageEnum.ZH },
        { id: 2, name: 'English', code: SystemLanguageEnum.EN },
        { id: 3, name: '日本語', code: SystemLanguageEnum.JA },
        { id: 4, name: '繁體中文', code: SystemLanguageEnum.ZH_TW },
        { id: 5, name: '한국어', code: SystemLanguageEnum.KO },
        { id: 6, name: 'हिंदी', code: SystemLanguageEnum.HI },
        { id: 7, name: 'Deutsch', code: SystemLanguageEnum.DE },
        { id: 8, name: 'العربية', code: SystemLanguageEnum.AR },
        { id: 9, name: 'Français', code: SystemLanguageEnum.FR },
        { id: 10, name: 'Indonesia', code: SystemLanguageEnum.ID },
        { id: 11, name: 'Italiano', code: SystemLanguageEnum.ITB },
        { id: 12, name: 'Українська', code: SystemLanguageEnum.UK },
    ])

    const systemLanguage = ref<SystemLanguageType>()
    const setLanguage = (code: SystemLanguageEnum) => {
        systemLanguage.value = languageList.value.find((item) => item.code === code)
    }
    return {
        languageList,
        systemLanguage,
        setLanguage
    }
}, {
    persist: {
        pick: ['systemLanguage'],
        storage: piniaPluginPersistedstate.localStorage()
    }
})

export default useSystemLaunageStore

export const useSystemLanguageStoreHook = () => {
    return useSystemLaunageStore(store)
}